import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
  width: 2.65rem;
  height: 2.65rem;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: .85rem;
  color: #fff;
  background: #000;
  cursor: pointer;
  box-shadow: 0 .55rem 1.2rem rgba(0,0,0,.14);
`;

const Lines = styled.span`
  width: 1.18rem;
  height: .86rem;
  position: relative;
  display: block;

  &::before,
  &::after,
  span {
    content: '';
    position: absolute;
    left: 0;
    width: 100%;
    height: 2px;
    border-radius: 999px;
    background: currentColor;
    transition: transform 180ms ease, top 180ms ease, opacity 180ms ease;
  }

  &::before {
    top: ${({ $opened }) => ($opened ? '.38rem' : '0')};
    transform: ${({ $opened }) => ($opened ? 'rotate(45deg)' : 'none')};
  }

  span {
    top: .38rem;
    opacity: ${({ $opened }) => ($opened ? 0 : 1)};
  }

  &::after {
    top: ${({ $opened }) => ($opened ? '.38rem' : '.76rem')};
    transform: ${({ $opened }) => ($opened ? 'rotate(-45deg)' : 'none')};
  }
`;

function Hamburger({ opened, clicked }) {
  return (
    <Button
      type="button"
      onClick={clicked}
      aria-label={opened ? 'Fermer le menu' : 'Ouvrir le menu'}
      aria-expanded={opened}
    >
      <Lines $opened={opened} aria-hidden="true"><span /></Lines>
    </Button>
  );
}

export default Hamburger;
